import { Link } from 'react-router';
import { Icon } from '../icon/Icon';
import type { Menu } from '../layout/sidebar/menu/SidebarMenu';
import { Stack } from '../stack/Stack';
import { Text } from '../text/Text';

export const NavigationTile = ({
  to,
  label,
  description,
  icon,
  adornment,
}: Menu) => {
  return (
    <Link
      aria-label={label}
      to={to}
      className="flex items-center gap-5 rounded-md px-5 py-3 border hover:bg-surface-disabled active:bg-surface-minimal-gray focus:bg-surface-subtle-gray border-action-tertiary-enabled hover:border-action-tertiary-hover focus:shadow-border-action-tertiary-focus focus-visible:outline-action-tertiary-focus active:border-action-tertiary-active disabled:border-action-tertiary-disabled text-content-body disabled:text-content-disabled"
    >
      <div className="relative">
        <Icon size={32} icon={icon} className="text-content-heading" />
      </div>
      <Stack>
        <Stack direction="row" gap="xs" className="items-center">
          <Text className="text-content-heading leading-snug">{label}</Text>{' '}
          {!!adornment && adornment(true)}
        </Stack>
        <Text
          variant="sm"
          className="line-clamp-1 leading-snug text-content-tertiary"
        >
          {description}
        </Text>
      </Stack>
    </Link>
  );
};
